import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'components/Layout'
import { useSpecificFeature } from 'hooks'
import SessionNew from '@legacy/pages/Account/SignIn'
import { NotificationProvider } from 'context'
import { ArcSessionNew } from './ArcSignIn'

export const SignIn = () => {
  const { i18n } = useTranslation()
  // Flipper endpoint: works unauthenticated, unlike the global features context (AR-792)
  const { enabled: arcNewProjectEnabled, loading: isFeatureLoading } =
    useSpecificFeature('arc-mosaico-project')

  useEffect(() => {
    if (!arcNewProjectEnabled) return
    if (i18n.language !== 'en') {
      i18n.changeLanguage('en')
    }
  }, [arcNewProjectEnabled, i18n.language])

  // Hold rendering until the flag resolves so neither branding flashes, and
  // until English is applied so the copy doesn't flash in another language (AR-792)
  if (isFeatureLoading) return null
  if (arcNewProjectEnabled && i18n.language !== 'en') return null

  return (
    <NotificationProvider>
      <Layout.Login>
        {arcNewProjectEnabled ? <ArcSessionNew /> : <SessionNew />}
      </Layout.Login>
    </NotificationProvider>
  )
}
